export default "__VITE_ASSET__DCKcwC5b__"